import { useState, useCallback } from 'react';
import { getUserReport } from '../../service/AdminService/userService';
import { showErrorMessage } from '../../components/shared/pagination/messages';

export const useUserHistory = () => {
    const [data, setData] = useState([]);

    const fetchReport = useCallback(async (userId, params = {}) => {
        if (!userId) return;
        try {
            setData([]);

            const response = await getUserReport(userId, params);

            if (response?.status === "SUCCESS") {
                const items = response.data?.items || [];

                const processed = items.map((item) => ({
                    ...item,
                    displayTitle: item.type === "BUNDLE" ? item.bundleName : item.courseTitle,
                    enrollmentType: item.enrollmentSource,
                    courseCompletionPercentage:
                        item.type === "BUNDLE" ? item.avgProgress : item.courseCompletionPercentage,
                    status: item.type === "BUNDLE" ? item.bundleStatus : item.status,
                    adherence: item.type === "BUNDLE" ? item.worstAdherence : item.adherence,
                }));

                setData(processed); 
                return response;
            }
        } catch (error) {
            showErrorMessage("Failed to load user report");
            console.error(error);
        }
    }, []);

    return { data, fetchReport };
};